import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

export const staggerDescFadeAnimation =
    trigger('staggerDescFade', [
        transition('* => *', [
            query(':enter', [
                style({ opacity: 0, transform: 'translate(0, -10px)' }),
                stagger('150ms', [
                    animate('250ms ease-in-out', style({ opacity: 1, transform: 'translate(0, 0)' }))
                ])
            ], { optional: true })
        ])
    ]);
